import PropTypes from 'prop-types'
import { Tabs } from 'antd'
import { getAllocatorMutualInterest } from '../../actions/allocator'
import { getAllocatorMutualInterestColumns } from '../../utils/columns'
import ContextTable from '../ContextTable'
import './MutualInterest.less'

const { TabPane } = Tabs

const MutualInterest = ({ companies }) => {
  const columns = getAllocatorMutualInterestColumns()

  const companyTabs = () => {
    return companies.map((x, i) => {
      //only have top matches for allocators currently
      if (x.categoryId === 2)
        return (
          <TabPane tab={<span>{x.name}</span>} key={i}>
            <ContextTable
              tableTitle="Mutual Interest Stats"
              columns={columns}
              dataMethod={getAllocatorMutualInterest.bind(
                null,
                x.companyContactId
              )}
              scroll={{ x: 1900 }}
            />
          </TabPane>
        )
      return null
    })
  }

  return (
    <>
      <Tabs size="large" className="UserActivity-tabs">
        {companyTabs()}
      </Tabs>
    </>
  )
}

MutualInterest.propTypes = {}

export default MutualInterest
